import React from "react";
import { ButtonSingle } from "../../../../../widget/common/form/Button";
import AppTranslation from "../../../../../service/app_translation/AppTranslation";
import { NewPasswordContextImport } from "../../../../../provider/onboarding/forgot_password/new_password/NewPasswordContextProvider";

const NewPasswordButtons = (props: { type?: number | undefined }) => {
  const { processing, submitPassword } = NewPasswordContextImport();

  return (
    <ButtonSingle
      handleClick={() => submitPassword()}
      width={300}
      processing={processing}
    >
      {AppTranslation.text("submit")}
    </ButtonSingle>
  );
};

export default NewPasswordButtons;
